import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getExtricationSelector } from '../selectors'
import { saveExtrication } from '../store/extrication.actions'
import { ExtricationConstants } from '../store/extrication.constants'
import { IExtricationState } from '../store/extrication.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const extricationState: IExtricationState = yield select(getExtricationSelector)
  const { successfulAttempt } = extricationState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.extricationStateList && pcrDoc.patient?.extricationStateList.length) {
      const index = pcrDoc.patient?.extricationStateList?.findIndex(
        (extrication) => extrication.key === extricationState.key
      )
      if (index !== -1) {
        if (pcrDoc.patient.extricationStateList[index].successfulAttempt !== successfulAttempt) {
          yield put(saveExtrication())
        }
      }
    } else {
      yield put(saveExtrication())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([ExtricationConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
